export const commonStyles = {
  section: "py-24",
  container: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
  heading: {
    primary: "text-3xl font-bold text-gray-900 mb-4",
    secondary: "text-xl text-gray-600"
  },
  card: {
    wrapper: "bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow",
    icon: "w-12 h-12 text-blue-600 mb-4",
    title: "text-xl font-semibold mb-2",
    description: "text-gray-600"
  },
  button: {
    primary: "bg-orange-500 text-white rounded-full hover:bg-orange-600 transition-colors",
    icon: "ml-2 group-hover:translate-x-1 transition-transform"
  }
}